import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Modules
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

// Components
import { NgbdDatepickerPopupEnhanced } from '../components/date-picker-enhanced.component';
import { DatepicketLocalizationService, I18n } from '../components/date-picker-enhanced-localization.service';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    NgbdDatepickerPopupEnhanced
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule
  ],
  exports: [
    NgbdDatepickerPopupEnhanced
  ],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatepicketLocalizationService }
  ],
})
export class DatePickerEnhancedModule { }
